import { convertObjToQueryString } from "../../utils/helpers";

export const getTrainerSlotsList = (
  data: { [key: string]: any },
  userId?: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_SLOT_MANAGEMENT_URL}/v1/get-coach-slots`,
    data,
    headers: {
      ...(!!userId && { "x-user-id": userId }),
    },
  };
};

export const editTrainerSlots = (
  data: { [key: string]: any },
  userId?: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_SLOT_MANAGEMENT_URL}/v1/edit-coach-slots`,
    data,
    headers: {
      ...(!!userId && { "x-user-id": userId }),
    },
  };
};

export const addTrainerSlots = (
  data: { [key: string]: any },
  userId?: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_SLOT_MANAGEMENT_URL}/v1/add-coach-slot`,
    data,
    headers: {
      ...(!!userId && { "x-user-id": userId }),
    },
  };
};

export const deleteTrainerSlots = (
  data: { [key: string]: any },
  userId?: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_SLOT_MANAGEMENT_URL}/v1/delete-coach-slots`,
    data,
    headers: {
      ...(!!userId && { "x-user-id": userId }),
    },
  };
};

export const getTrainerSessionsList = (
  queryObj: { [key: string]: any },
  userId?: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_SLOT_MANAGEMENT_URL}/v1/trainer/bookings${query}`,
    headers: {
      ...(!!userId && { "x-user-id": userId }),
    },
  };
};

export const getUserSessionsList = (
  queryObj: { [key: string]: any },
  userId?: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_SLOT_MANAGEMENT_URL}/v1/trainer/user/bookings${query}`,
    headers: {
      ...(!!userId && { "x-user-id": userId }),
    },
  };
};

export const markUserAttendence = (
  queryObj: { [key: string]: any },
  userId?: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "POST",
    url: `${process.env.REACT_APP_SLOT_MANAGEMENT_URL}/v1/mark-attendance${query}`,
    headers: {
      ...(!!userId && { "x-user-id": userId }),
    },
  };
};
